import axiosInstance from 'Utils/axiosInstance';
import { mapDtoToIntegration, sortItems } from 'Utils/mappers';

export async function getIntegrations() {
    const [erpsResponse, channelsResponse] = await Promise.all([
        axiosInstance.get('/erps'),
        axiosInstance.get('/channels'),
    ]);

    const erps = erpsResponse?.data ?? [];
    const channels = channelsResponse?.data ?? [];

    return [...erps, ...channels].sort(sortItems).map(mapDtoToIntegration);
}


export async function editErp(erpId, data) {
    const response = await axiosInstance.put(`/erps/${erpId}`, data);

    if (!response?.data) return [];

    return mapDtoToIntegration(response.data);
}

export async function editChannel(channelId, data) {
    const response = await axiosInstance.put(`/channels/${channelId}`, data);

    if (!response?.data) return [];

    return mapDtoToIntegration(response.data);
}

export async function deleteErp(erpId) {
    await axiosInstance.delete(`/erps/${erpId}`);
}

export async function deleteChannel(channelId) {
    await axiosInstance.delete(`/channels/${channelId}`);
}


export async function sendChannelInstructions(channelConnectionId) {
    await axiosInstance.post(`/channels/${channelConnectionId}/instructions`);
}

export async function createIntegrationChannel(service, address, otp, integrationId) {
    await axiosInstance.post('/channels', { service, address, otp, channel_id: integrationId ?? null });
}

export async function createIntegrationChannelResend(service, address) {
    try {
        await axiosInstance.post('/channels', { service, address, otp: null, channel_id: null });
    } catch (error) {
        handleResendError(error);
    }
}

function handleResendError(error) {
    if (error.response?.status === 400 && error.response.data.description === 'requires_verification') {
        return;
    }

    throw error;
}

export async function createIntegrationERP(
    service,
    token,
    host = null,
    database = null,
    username = null,
    password = null,
    workspace_id = null,
    signing_secret = null,
) {
    const response = await axiosInstance.post('/erps', {
        service,
        token,
        host,
        database,
        username,
        password,
        workspace_id,
        signing_secret,
    });
    return response?.data ? mapDtoToIntegration(response.data) : null;
}


export async function synchronizeIntegration(integrationId) {
    await axiosInstance.post(`/erps/${integrationId}/synchronize`);
}

export async function uploadContactToERP(integrationId, contactId) {
    const response = await axiosInstance.post(`/erps/${integrationId}/contact`, {
        contact_id: contactId,
    });
    return response.data;
}

export async function uploadInvoiceToERP(integrationId, invoiceId) {
    const response = await axiosInstance.post(`/erps/${integrationId}/invoice`, {
        invoice_id: invoiceId,
    });
    return response.data;
}

